// extracted by mini-css-extract-plugin
export default {"DeleteLibraryTagDialog":"DeleteLibraryTagDialog_DeleteLibraryTagDialog__6FMVD"};